import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Pipe({
    name: 'sortData',
    standalone: false
})
export class SortDataPipe implements PipeTransform {
    constructor(public util:UtilService){

    }
  

  transform(value: any, ...args: any[]): any {
    try {
      let field = args[0];
      if (value != undefined && Array.isArray(value) && value.length > 0 && !field['stopSorting']) {
        if(field["sortType"] != undefined && field["sortType"]){
          return this.util.sort(value, field["sortType"]);
        }else{
          return value.sort((firstElement, secondElement) => (firstElement.mixdata[field['getterValue']].toLowerCase() > secondElement.mixdata[field['getterValue']].toLowerCase()) ? 1 : ((secondElement.mixdata[field['getterValue']].toLowerCase() > firstElement.mixdata[field['getterValue']].toLowerCase()) ? -1 : 0))
        }
        
      }
      else if (value != undefined && Array.isArray(value) && value.length > 0 && field['stopSorting']!=undefined && field['stopSorting']) {
        return value;
      }
    } catch (error) {
      if (value != undefined && Array.isArray(value) && value.length > 0) {
        return value;
      }
     }
  }

}